import { useLocation, useNavigate } from 'react-router-dom';

import { useCallback } from 'react';

/**
 * Hook to handle back navigation using browser history
 * Falls back to a default URL if no in-app history is available
 */
export function useBackNavigation(fallbackUrl?: string): () => void {
  const navigate = useNavigate();
  const location = useLocation();

  const goBack = useCallback(() => {
    // location.key === 'default' means this is the initial history entry
    // (deep link, refresh, or notification) — there is no in-app page to go back to.
    // window.history.length is unreliable here because it counts the entire browser
    // session and any forward entries, which led to back-button loops.
    if (location.key !== 'default') {
      navigate(-1);
    } else {
      navigate(fallbackUrl ?? '/groups', { replace: true });
    }
  }, [navigate, fallbackUrl, location.key]);

  return goBack;
}
